import { gql } from '@apollo/client';

export const ActiveSnoozeStatusFragment = gql`
    fragment ActiveSnoozeStatus on WorkQueueStatus {
        activeSnooze {
            id
            snoozedUntil
            createdAt
            reason
            snoozedBy {
                id
                fullName
                email
            }
        }
    }
`;

export type RowSnoozeStatus = {
    workQueueStatus?: {
        activeSnooze: {
            snoozedUntil: Date;
            createdAt: Date;
            reason: string | null;
            snoozedBy: { fullName: string; email: string } | null;
        } | null;
    };
};
